import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { NgForm } from "@angular/forms";
import { DateAdapter } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { DatePipe } from "@angular/common";
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { EnquiryentryService } from "./shared/enquiryentry.service";
import { Employee } from '../login/shared/employee';
import { dashCaseToCamelCase } from '@angular/compiler/src/util';


@Component({
  selector: 'app-enquiry',
  templateUrl: './enquiry.component.html',
  styleUrls: ['./enquiry.component.css']
})

export class EnquiryComponent implements OnInit {

  AddButtonText: string = "Add";
  ErrorText: string;
  AutoGeneratedEnquiryNo: number;
  ParentEnquiryNo: number;
  StaffList: any[] = [];
  selectedStaff: any[] = [];
  readonlyTextBox: boolean;

  displayedColumns: string[] = ['Id', 'Name', 'Address', 'Guardian', 'Relation', 'MobileNo', 'New'];

  dataSourceList = new MatTableDataSource<any>();
 @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(public enquiryentryService: EnquiryentryService, private dateAdapter: DateAdapter<Date>,
    private router: Router, private activatedRoute: ActivatedRoute, private datePipe: DatePipe) {
    // this.dateAdapter.setLocale('en-GB');
  }

  ngOnInit() {

    this.activatedRoute.params.subscribe(param => {
      this.ParentEnquiryNo = + param['Id'];  //EnquiryNo
    });

    this.resetForm();
    this.getAutogeneratedNumber();
    this.GetStaff();
    this.getEnquiryEntryByEnquiryNo();   
    
    this.dataSourceList.paginator = this.paginator;

    if (Number.isNaN(this.ParentEnquiryNo)) {
      this.enquiryentryService.selectedEnqiryentry.Id = 0;
      this.enquiryentryService.selectedEnqiryentry.Flag = 1;
      this.enquiryentryService.selectedEnqiryentry.IsActive = true;
      this.AddButtonText = "Add";
    }
    else {
      this.enquiryentryService.selectedEnqiryentry.Id = +this.ParentEnquiryNo;
      this.enquiryentryService.selectedEnqiryentry.Flag = 2;
      this.enquiryentryService.selectedEnqiryentry.IsActive = true;
      // this.readonlyTextBox = true;
      this.AddButtonText = "Edit";

      this.getEnquiryCustomersByEnquiryNo();
      // this.getEnquiryStaffByEnquiryNo();   
    }
  }

  resetForm(form?: NgForm) {
    if (form != null)
      form.reset();

    this.enquiryentryService.selectedEnqiryentry = {
        Id: null,
        EnquiryNo: this.getEnquiryNumber(),
        EnquiryDate: JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"],
        PreMeetingDate: JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"],
        MeetingPlace: null,
        Area: null,
        Distance: null,
        MemberVisited: null,
        MemberExpected: null,
        EmployeeId: null,
        EmployeeBranchId: null,
        CompanyId: null,
        SaasId: null,
        CreatedDate: null,
        ModifiedDate: null,
        IsActive: true,
        Flag: 1,
        EditGridFlag: 1,

      enquiryEntryDetails: [{
        Id: null,
        EnquiryId: null,
        Name: null,
        Address: null,
        Guardian: null,
        RelationId: null,
        MobileNo: null,
        IsActive: true,
      }],

      EmployeeList: [{
        Id: null,
        Name: null,
        Code: null,
        UserName: null,
        Password: null,
        AreaId: null,
        RegionId: null,
        BranchId: null,
        CountryId: null,
        SaasId: null,
        IsActive: null,
        CompanyId: null,
      }],
    }
  }

  public onSubmit(form: NgForm) {
    console.log("On submit");

    console.log('Form Status', form.valid);
    console.log('Form Touched', form.touched);
    console.log('Form Untouch', form.untouched);
    console.log('Form Invalid', form.invalid);
    console.log('Form Pristine', form.pristine);

    // selecting the staff from selectedStaff
    if (this.selectedStaff != null) {
      this.enquiryentryService.selectedEnqiryentry.EmployeeList = [];
      const myData = this.selectedStaff.map((row) => {
        let employee = new Employee();
        employee.Id = row;
        employee.Name = ' ';
        employee.Code = ' ';
        employee.UserName = ' ';
        employee.Password = ' ';
        employee.AreaId = 0;
        employee.RegionId = 0;
        employee.BranchId = 0;
        employee.CountryId = 0;
        employee.SaasId = ' ';
        employee.IsActive = 0;

        this.enquiryentryService.selectedEnqiryentry.EmployeeList.push(employee);
        // return { empList : this.enquiryentryService.selectedEnqiryentry.EmployeeList }
      });
    }
    form.value.Id = + this.ParentEnquiryNo;
    form.value.enquiryEntryDetails = this.dataSourceList.data;
    form.value.EmployeeList = this.enquiryentryService.selectedEnqiryentry.EmployeeList;
    // console.log(this.enquiryentryService.selectedEnqiryentry.EmployeeList); 

    this.enquiryentryService.IUDEnquiryentry(form.value)
      .subscribe(data => {
        // this.resetForm(form);
        this.router.navigate(['/enquirylist']);
      })
  }

  getAutogeneratedNumber(): any {
    if (Number.isNaN(this.ParentEnquiryNo)) { // Parent enquiry number checks
      const myAutoGeneratedId = this.enquiryentryService.FetchAutogeneratedNumber()
        .toPromise()
        .then(res => {
          this.enquiryentryService.selectedEnqiryentry.EnquiryNo = res[0].AutoGeneratedId;
          this.AutoGeneratedEnquiryNo = res[0].AutoGeneratedId;
          return Promise.resolve(res[0].AutoGeneratedId);
        })
        .catch(err => { console.log(err) });
    }
    else {
      this.AutoGeneratedEnquiryNo = this.ParentEnquiryNo;
    }
  }

  getEnquiryNumber(): number {
    if (this.ParentEnquiryNo == undefined) {
      return this.AutoGeneratedEnquiryNo;
    }
    else {
      return this.AutoGeneratedEnquiryNo = this.ParentEnquiryNo;
    }
  }

  getEnquiryEntryByEnquiryNo() {

    if (!Number.isNaN(this.ParentEnquiryNo)) {
      this.enquiryentryService.selectedEnqiryentry.Id = + this.ParentEnquiryNo;
      this.enquiryentryService.selectedEnqiryentry.EditGridFlag = 1;
      this.enquiryentryService.FetchEnquiryEntryByEnquiryNo(this.enquiryentryService.selectedEnqiryentry).subscribe(data => {
        this.enquiryentryService.selectedEnqiryentry = data;
        this.enquiryentryService.selectedEnqiryentry.Flag = 2;
        // this.enquiryentryService.selectedEnqiryentry.EnquiryDate=new Date( Date.parse( this.datePipe.transform(data.Enquirydate,"yyyy-MM-dd")));
        // this.enquiryentryService.selectedEnqiryentry.EnquiryDate =new Date(  Date.parse( new DatePipe('en-US').transform(data.Enquirydate, 'dd/MM/yyyy')));
      })
    }
  }

  getEnquiryCustomersByEnquiryNo() {

    if (!Number.isNaN(this.ParentEnquiryNo)) {
      this.enquiryentryService.selectedEnqiryentry.Id = + this.ParentEnquiryNo;
      this.enquiryentryService.selectedEnqiryentry.EditGridFlag = 2;
      this.enquiryentryService.FetchEnquiryCustomersByEnquiryNo(this.enquiryentryService.selectedEnqiryentry).subscribe(data => {

        data.forEach(dataRow => {
          this.dataSourceList.data.length + 1;
          this.dataSourceList.data.push(dataRow);
        });
        this.dataSourceList.filter = "";
        this.enquiryentryService.selectedEnqiryentry.Flag = 2;
        // this.enquiryentryService.selectedEnqiryentry.EnquiryDate=new Date( Date.parse( this.datePipe.transform(data.Enquirydate,"yyyy-MM-dd")));
        // this.enquiryentryService.selectedEnqiryentry.EnquiryDate =new Date(  Date.parse( new DatePipe('en-US').transform(data.Enquirydate, 'dd/MM/yyyy')));
      })
    }
  }

  // Adds new Customer.
  addRow(e) {

    this.dataSourceList.data.push(this.createNewCustomer(this.dataSourceList.data.length + 1));
    this.dataSourceList.filter = "";
    e.stopPropagation();
    return false;
  }

  // Creates new Customer.
  createNewCustomer(id: number): any {

    return this.enquiryentryService.selectedEnquiryentrydetails = {
      Id: id,
      EnquiryId: null,
      Name: null,
      Address: null,
      Guardian: null,
      RelationId: null,    //   Relation:[],
      MobileNo: null,
      IsActive: true,
    };
  }

  GetStaff() {
    this.enquiryentryService.FetchStaffList().toPromise().then(data => {
      this.StaffList = data;
      this.getEnquiryStaffByEnquiryNo();  
    })
  }

  getEnquiryStaffByEnquiryNo() {
    if (!Number.isNaN(this.ParentEnquiryNo)) {
      this.enquiryentryService.selectedEnqiryentry.Id = + this.ParentEnquiryNo;
      this.enquiryentryService.FetchStaffListbyEnquiryId(this.enquiryentryService.selectedEnqiryentry.Id)
        .subscribe(data => {

      //   for(var i=0; i< data.length; i++){
      //     // this.selectedStaff[i] = data[i].Id; 
      //     // this.selectedStaff.push(data[i].Id,data[i].Name);
      //  }
      //  console.log( this.selectedStaff);
      // // this.selectedStaff = Array.of( this.selectedStaff);

       
      const myData = data.map((row) => {
        let employee = new Employee();
        employee.Id = row.Id;
        employee.Name =  row.Name;
        employee.Code = ' ';
        employee.UserName = ' ';
        employee.Password = ' ';
        employee.AreaId = 0;
        employee.RegionId = 0;
        employee.BranchId = 0;
        employee.CountryId = 0;
        employee.SaasId = ' ';
        employee.IsActive = 0;

        this.selectedStaff.push(employee);
        return { empList : this.selectedStaff }
      });

      })

      // console.log(" this.selectedStaff");
      // console.log( this.selectedStaff);
      // console.log("------------------------");
      // console.log(" this.StaffList");
      // Array.of( this.selectedStaff);
      // console.log( this.StaffList);

    }
  }

  selectChange($event: Event) {
    // console.log(this.selectedStaff);
  }

}
